module.exports = __webpack_public_path__ + "img/Strategy for A Social City in Indonesia.d21d3af3.jpg";